import type { ComponentType } from '@grafikr/components';
import Splide from '@splidejs/splide';

import productItemLoading from 'utils/product-item-loading';
import setUrlParams from 'utils/set-url-params';

const Component: ComponentType = (node, { app }) => {
  const { logic, rulesetId, limit, productId } = node.dataset;

  const carousel = new Splide(node, {
    autoWidth: true,
    focus: 0,
    omitEnd: true,
    pagination: false,
    flickPower: 200,
  }).mount();

  const fetchRecommendations = async () => {
    const url = new URL(`https://rebuyengine.com/api/v1`);

    if (logic === 'custom') {
      url.pathname += `/custom/id/${rulesetId}`;
    } else {
      url.pathname += `/products/${logic}`;
    }

    setUrlParams(url, {
      key: theme.integrations.rebuyApiKey,
      shopify_product_ids: productId,
      limit,
    });

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(
        `Could not fetch product recommendations. Server responded with: ${response.status}`,
      );
    }

    return response.text();
  };

  const initRecommendations = async () => {
    const { default: stringMemory } = await import(
      /* webpackChunkName: "string-memory" */ 'utils/string-memory'
    );
    const memory = stringMemory(sessionStorage);

    try {
      const response = await memory.get(
        `rebuy-products-${logic}-${productId ?? 'none'}`,
        fetchRecommendations,
      );

      JSON.parse(response).data.forEach((item) => {
        const slide = document.createElement('li');
        slide.classList.add('splide__slide', 'w-5/12', 'lg:w-1/4');

        const lazyContent = document.createElement('div');
        lazyContent.setAttribute('data-component', 'lazy-content');
        lazyContent.setAttribute('data-url', `/products/${item.handle}?view=item`);

        lazyContent.appendChild(<Node>productItemLoading());
        slide.append(lazyContent);

        carousel.add(slide);
      });
      carousel.remove('.js-placeholder');

      app.mount();
    } catch (e) {
      node.remove();

      throw e;
    }
  };

  initRecommendations();
};

export default Component;
